angular.module('app').controller('LineItemCtrl', function($http, $mdDialog, lineItem, photos, order, appUtils, $mdToast, $route) {

    var main = this;
    main.saving = false;
    main.photos = photos;
    main.order = order;
    main.lineItem = lineItem;
    main.updated = angular.copy(lineItem);
    main.current = lineItem;

    $http({'method': 'GET', 'url': '/api/v1/admin/product/' + main.lineItem.item.product_id}).then(
        function(results) {
            main.product = results.data;
        }
    );

    main.priceList = angular.copy(main.order.price_list);
    console.log(main.priceList);
    main.priceList.categories.forEach(function(cat) {
        cat.items = cat.items.filter(function(item) { return item.product.type != 'package'; })
    })
    main.priceList.categories = main.priceList.categories.filter(
        function(cat) { return cat.items.length > 0; }
    );

    main.updateOptions = function() {
        main.options = main.product.options.map(function(option) {
            var opt = option.options;
            opt.id = option.id;
            return opt;
        });
    }

    main.updateProduct = function() {
        main.updated.item_id = main.item.id;

        $http({'method': 'GET', 'url': '/api/v1/admin/product/' + main.item.product.id}).then(
            function(results) {
                main.product = results.data;
                main.updated.name = main.product.name;
                main.options = main.product.options.map(function(option) {
                    var opt = option.options;
                    opt.id = option.id;
                    return opt;
                });
            }
        );
    };

    main.updatePhoto = function(photo) {
        main.updated.photo_id = photo.id;
        main.photo = photo;
        main.save();
    };

    main.save = function() {
        if(!main.updated.id) {
            main.lineItem.quantity = main.updated.quantity;

            if(main.photo) {
                main.lineItem.photo = main.photo;
                main.lineItem.photo_id = main.photo.id;
            }

            if(main.updated.item_id) {
                main.lineItem.item_id = main.updated.item_id;
                main.lineItem.options = main.updated.options;
            }

            if(main.item) {
                main.lineItem.item.name = main.item.product.name;
                main.lineItem.name = main.item.product.name;
            }

            if(main.options) {
                main.lineItem.item.options = main.options.map(
                    function(opt) {
                        return {
                            'id': opt.id,
                            'options': opt
                        }
                    }
                );
            }
            $mdDialog.hide();
            return;
        }
        var url = '/api/v1/admin/line_item/' + main.updated.id;
        delete(main.updated.item);
        delete(main.updated.photo);
        delete(main.updated.total);
        main.saving = $http({'method': 'PUT', 'url': url, 'data': main.updated}).then(
            function(results) {
                var message = "Item saved";
                var alert = $mdToast.simple().textContent(message);
                $mdToast.show(alert);
                $mdDialog.hide();
                $route.reload();
            }
        );
    };
});
